package com.essntl.features.invoice.ui.addeditinvoice.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.TransformOrigin
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun RowScope.ExpandCollapseArrowWithText(
    text: String,
    isExpanded: Boolean,
    onToggleExpanded: () -> Unit,
) {
    Text(
        text = text,
        style = MaterialTheme.esTypography.p1Regular16,
        color = MaterialTheme.esColorScheme.textSecondary
    )

    Spacer(modifier = Modifier.width(2.spacing))

    EsLargeIcon(
        res = EsIcons.ArrowDown,
        modifier = Modifier
            .graphicsLayer {
                transformOrigin = TransformOrigin.Center
                rotationZ = if (isExpanded) 180f else 0f
            }
            .clip(CircleShape)
            .pointerHoverIcon(PointerIcon.Hand)
            .clickable(
                interactionSource = remember { MutableInteractionSource() },
                indication = null,
            ) {
                onToggleExpanded()
            },
    )
}